export const formatCurrency = (amount: number) => {
    if (amount >= 1000000) return `$${(amount / 1000000).toFixed(2)}M`;
    if (amount >= 1000) return `$${(amount / 1000).toFixed(1)}K`;
    return `$${(amount ?? 0).toFixed(2)}`;
};

export const formatNumber = (num: number) => {
    const n = num ?? 0;
    if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
    if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
    return n.toLocaleString();
};

export const CHART_COLORS = ['#171717', '#525252', '#737373', '#a3a3a3', '#d4d4d4'];

export const tooltipStyle = {
    backgroundColor: '#fff',
    border: '1px solid #e5e5e5',
    borderRadius: 0,
    fontSize: 10,
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
};
